<script>
export default {
  props: ['value'],
  data() {
    return {
      header: this.value.header,
    };
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header(:class="$style.header")
    div(:class="$style.headerTitle") {{ $t(header) }}
  div(:class="$style.content")
    ui-progress(:class="$style.load")
</template>

<style lang="sass" module>
.root
  display: block
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
    max-width: 600px
    text-align: center
    overflow-wrap: break-word
    word-wrap: break-word
    word-break: break-all
    word-break: break-word
.content
  padding: 24px
  min-width: 532px
  display: flex
  justify-content: space-around
.load
  position: absolute
  height: 4px
  top: 0
  left: 0
  right: 0

</style>
